"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WS_PING = exports.WEBSOCKETS = exports.NOTIFICATION_V2 = exports.NOTIFICATION = exports.ERROR = void 0;
const ERROR = exports.ERROR = 1;
const NOTIFICATION = exports.NOTIFICATION = 2;
const NOTIFICATION_V2 = exports.NOTIFICATION_V2 = 'shared:notifications:notification';
const WS_PING = exports.WS_PING = 3;
const WEBSOCKETS = exports.WEBSOCKETS = {
  WS: 'ws',
  UA: 'ua'
};